import { useNavigate } from 'react-router-dom';
import { useEmailVerificationGrace } from '../useAuth/useEmailVerificationGrace';
import { useAuth } from '../useAuth';

export const usePageGuard = (
  userId,
  historyId,
  loading,
  history,
  selectedHistory,
  isStreaming,
  backgroundReconnect
) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { isGraceExpired } = useEmailVerificationGrace(user);

  // 사용자 인증 확인
  if (!userId) {
    return { shouldRender: false, reason: 'no-user' };
  }

  // 유예 기간 만료 체크 - 랜딩페이지로 리다이렉트하면서 모달 표시
  if (isGraceExpired) {
    console.log('🚫 [PageGuard] 유예 기간 만료로 인한 접근 차단, 랜딩페이지로 리다이렉트');
    
    // 랜딩페이지로 리다이렉트하면서 모달 표시를 위한 플래그 설정
    sessionStorage.setItem('showBlockModal', 'true');
    navigate('/', { replace: true });
    return { shouldRender: false, reason: 'grace-expired' };
  }

  // 백그라운드 재연결 중이거나 처리 중인 경우 검증 생략
  if (backgroundReconnect?.isReconnecting || backgroundReconnect?.backgroundProcessing) {
    console.log('🔄 [PageGuard] 백그라운드 재연결/처리 중이므로 검증 생략', {
      isReconnecting: backgroundReconnect?.isReconnecting,
      backgroundProcessing: backgroundReconnect?.backgroundProcessing
    });
    return { shouldRender: true, reason: 'background-reconnect' };
  }

  // 히스토리 로딩이 완료되었는데 historyId가 있지만 해당 히스토리가 없는 경우
  if (historyId && !loading && history.length > 0 && !selectedHistory && !isStreaming) {
    console.warn(`⚠️ [AnalyzePage] 히스토리 로딩 완료 후에도 찾을 수 없음: ${historyId}`);
    navigate('/', { replace: true });
    return { shouldRender: false, reason: 'invalid-history' };
  }

  // 모든 조건을 통과한 경우
  return { shouldRender: true };
}; 